import 'public/js/font'